<script>
import Loader from "@/components/widgets/loader";
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric"; 
import tlptalep from "@/models/tlptalep"; 
export default {
  mixins: [Api, Sabit, tlptalep],
  page: {
    title: "Personelin Baktığı Talepler",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    Layout,
    PageHeader
  },
  data() {
    return {
      title: "Personelin Baktığı Talepler",
      items: [
        {
          text: "Anasayfa",
          href: "/",
        },
        {
          text: "Raporlar",
          href: "/",
        },
        {
          text: "Personelin Baktığı Talepler",
          active: true,
        },
      ], 
      TableData: {}, 
      loading: true,
      Filter: {
        Createdbas: null,
        Createdbit: null, 
      }
    };
  },

  methods: {
    Get() {
      var Filter = "&Desc="

      if (this.Filter.Createdbas != null && this.Filter.Createdbas != "") {
        Filter += "&Createdbas=" + this.Filter.Createdbas
      }
      if (this.Filter.Createdbit != null && this.Filter.Createdbit != "") {
        Filter += "&Createdbit=" + this.Filter.Createdbit
      } 
 
      this.ActionsFilterGet({
        Service: "tlptalep/getpersoneltalep",
        FullData: true,
        Filter: Filter,
      }).then((res) => {
        this.TableData = res.Data; 
        this.loading = false;
      });
    },
    IsGucu(Data){ 
      const uniqueTalepler = Data.filter(
        (item, index, self) => self.findIndex((t) => t.id === item.id) === index); 
      const toplamIsgucu = uniqueTalepler.reduce((sum, talep) => sum + talep.isgucu, 0); 
      return toplamIsgucu ? toplamIsgucu.toFixed(2) : ''
    },
    HarcananZaman(Data){ 
      const uniqueTalepler = Data.filter(
        (item, index, self) => self.findIndex((t) => t.id === item.id) === index); 
      const toplamharcananzaman = uniqueTalepler.reduce((sum, talep) => sum + talep.harcananzaman, 0);  
      return toplamharcananzaman ? toplamharcananzaman.toFixed(2) : ''
    },
    Talepler(Data) { 
      const uniqueTalepler = Data.filter(
          (item, index, self) => self.findIndex((t) => t.id === item.id) === index
        );
      
        let Talep = "";
        uniqueTalepler.forEach(element => {
          if (Talep) {
            Talep += ", " + element.takipno + "(" + element.baslik + ")";
          } else {
            Talep += element.takipno + "(" + element.baslik + ")";
          }
        });
        
        return Talep;
      },
    
    groupBy(array, key) {
      return array.reduce((result, current) => {
        (result[current[key]] = result[current[key]] || []).push(current);
        return result;
      }, {});
    },

  },
};
</script>

<template>
  <Loader :loading="loading">
    <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="row mb-2">
                <div class="col-sm-4">
                  
                </div>
                <div class="col-sm-8">
                  <div class="text-sm-end"></div>
                </div>
              </div>
              <div class="accordion mb-3"  >
                <div class="accordion-item">
                  <h2 class="accordion-header" id="panelsStayOpen-headingOne">
                    <button class="accordion-button" type="button" data-bs-toggle="collapse"
                      data-bs-target="#panelsStayOpen-collapseOne" aria-expanded="true"
                      aria-controls="panelsStayOpen-collapseOne">
                      Filtreleme
                    </button>
                  </h2>
                  <div id="panelsStayOpen-collapseOne" class="accordion-collapse collapse show"
                    aria-labelledby="panelsStayOpen-headingOne">
                    <div class="accordion-body">

                      <div class="row">

                        <b-form-group class="col-lg-3" label="Başlama Tarihi"  >
                          <b-form-input  v-model="Filter.Createdbas"   type="date"  ></b-form-input>
                      
                          </b-form-group>
                        <b-form-group class="col-lg-3" label="Bitiş Tarihi"  >
                          <b-form-input  v-model="Filter.Createdbit"   type="date"  ></b-form-input>
                      
                          </b-form-group>


                        <div class="col-lg-3">
                          <button class="btn btn-success mt-4" data-bs-dismiss="offcanvas" type="button"
                            data-bs-target="#demo" @click="Get()">
                            Filtreleme
                          </button>
                        </div>

                      </div>


                    </div>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <table class="table mb-0">
                  <thead class="table-light">
                    <tr>
                      <th>Personel</th>
                      <th>Talepler</th>
                      <th>İş Gücü</th>  
                      <th>Harcanan Zaman</th>  
                      </tr>
                  </thead>
                  <tbody>
                    <tr v-for="Data in TableData" :key="Data.Id">
                      <th scope="row">{{ Data.Adsoyad }}</th> 
                      <td>{{  Data.Talepler ? Talepler(JSON.parse(Data.Talepler)) :'-' }}</td> 
                      <td>{{  Data.Talepler ? IsGucu(JSON.parse(Data.Talepler)) :'-' }}</td> 
                      <td>{{  Data.Talepler ? HarcananZaman(JSON.parse(Data.Talepler)) :'-' }}</td> 
                      
                    </tr>
                  </tbody>
                </table> 
              </div>
            </div>
          </div>
        </div>
      </div>
 
    </Layout>
  </Loader>
</template>
